import { SparklesIcon } from "@heroicons/react/24/solid"
import React from "react"

type Props = {
  className?: string
  /** Tailwind classes for the logo SVG (height drives scale; aspect ~20:29). */
  logoClassName?: string
  /** Tailwind classes for the sparkles badge. */
  sparkleClassName?: string
  /** `onTeal`: white H for teal/dark buttons. `brand`: navy H from healme_logo.svg. */
  variant?: "onTeal" | "brand"
}

/** Heal.me “H” mark from public/images/healme_logo.svg plus sparkles (AI). */
export default function HealmeAiMark({
  className = "",
  logoClassName = "h-7 w-auto aspect-[20/29]",
  sparkleClassName,
  variant = "onTeal"
}: Props) {
  const gradId = React.useId().replace(/:/g, "")
  const hFill = variant === "onTeal" ? "#FFFFFF" : "#0B3954"
  const sparkles =
    sparkleClassName ??
    (variant === "onTeal"
      ? "absolute -right-0.5 -top-1 h-3.5 w-3.5 text-amber-200 drop-shadow-sm"
      : "absolute -right-0.5 -top-1 h-3.5 w-3.5 text-teal-500 drop-shadow-sm")

  return (
    <span className={`relative inline-flex items-center justify-center ${className}`}>
      <svg
        className={logoClassName}
        viewBox="0 0 20 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden>
        <path
          d="M0 28.125V0H4.14062V11.875C4.79167 10.7552 5.6901 9.88281 6.83594 9.25781C8.00781 8.60677 9.29687 8.28125 10.7031 8.28125C13.0208 8.28125 14.8437 9.01042 16.1719 10.4687C17.5 11.9271 18.1641 14.1016 18.1641 16.9922V28.125H14.0625V17.4219C14.0625 13.6719 12.5651 11.7969 9.57031 11.7969C8.00781 11.7969 6.70573 12.3437 5.66406 13.4375C4.64844 14.5312 4.14062 16.0937 4.14062 18.125V28.125H0Z"
          fill={hFill}
        />
        <path
          d="M17.3437 5.19531C16.5625 5.19531 15.9115 4.94791 15.3906 4.45312C14.8958 3.93229 14.6484 3.32031 14.6484 2.61719C14.6484 1.88802 14.8958 1.27604 15.3906 0.781249C15.9115 0.260416 16.5625 0 17.3437 0C18.125 0 18.763 0.260416 19.2578 0.781249C19.7526 1.27604 20 1.88802 20 2.61719C20 3.32031 19.7526 3.93229 19.2578 4.45312C18.763 4.94791 18.125 5.19531 17.3437 5.19531Z"
          fill={`url(#hm_ai_grad_${gradId})`}
        />
        <defs>
          <linearGradient
            id={`hm_ai_grad_${gradId}`}
            x1="19.0352"
            y1="0.462083"
            x2="15.9677"
            y2="4.82584"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#F4B965" />
            <stop offset="1" stopColor="#F58C72" />
          </linearGradient>
        </defs>
      </svg>
      <SparklesIcon className={sparkles} aria-hidden />
    </span>
  )
}
